/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Form_Intro_After_EmailInputs */

const tr_contact_form_intro_after_email = /** @type {(inputs: Contact_Form_Intro_After_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`adresini kullan.`)
};

const en_contact_form_intro_after_email = /** @type {(inputs: Contact_Form_Intro_After_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`.`)
};

const de_contact_form_intro_after_email = /** @type {(inputs: Contact_Form_Intro_After_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` anstelle von Screenshots.`)
};

const ru_contact_form_intro_after_email = /** @type {(inputs: Contact_Form_Intro_After_EmailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (` вместо прикрепления скриншотов.`)
};

/**
* | output |
* | --- |
* | "." |
*
* @param {Contact_Form_Intro_After_EmailInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const contact_form_intro_after_email = /** @type {((inputs?: Contact_Form_Intro_After_EmailInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Form_Intro_After_EmailInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_contact_form_intro_after_email(inputs)
	if (locale === "de") return de_contact_form_intro_after_email(inputs)
	if (locale === "ru") return ru_contact_form_intro_after_email(inputs)
	return tr_contact_form_intro_after_email(inputs)
});